var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.template_name === 'template3')?_c('Pager3'):(_vm.template_name === 'template2')?_c('Pager2'):_c('Pager1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }